// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3VB-4","errors":"Errors_errors__1qPRJ"};